// Loads meta/fixtures/default.json at Vite build time. Used by
// PreviewTab as the substitution source for cells that don't have a
// path-inferred fixture (i.e., master templates under
// content/notebook-scaffold/cells/).
//
// JSON over YAML so we don't need a YAML parser dep — Vite has native
// JSON support via import.meta.glob with eager: true.
//
// Note: import.meta.glob is a Vite COMPILE-TIME macro, not a runtime
// function. The literal call below is replaced at build time with a
// frozen { '/path': importedJsonObject } record. Wrapping it in a
// `typeof meta.glob === 'function'` runtime guard would always be
// false in the browser (the macro disappears post-transform) — the
// same gotcha E1 Task 18 (commit 9dc9378) fixed for the cell-loader.
// We use try/catch so bun:test (no Vite transform) falls back to an
// empty fixture without throwing.

import type { Fixture } from './apply-fixture';

let cached: Fixture | null = null;

function loadDefaultFixtureFromGlob(): Fixture | null {
  try {
    const map = import.meta.glob('../../../../meta/fixtures/*.json', {
      eager: true,
      import: 'default',
    }) as Record<string, Fixture>;
    for (const [key, value] of Object.entries(map)) {
      if (key.endsWith('default.json')) return value;
    }
    return null;
  } catch {
    // bun:test or any non-Vite context: import.meta.glob is undefined.
    return null;
  }
}

export function getDefaultFixture(): Fixture {
  if (cached) return cached;
  const loaded = loadDefaultFixtureFromGlob();
  cached = loaded ?? {};
  return cached;
}
